const WHATSAPP_GATEWAY_IDENTITY = 'postmaster@wa.gw.msging.net';
const WHATSAPP_NATIVE_BASE_URI = '/native/v1';
/**
 * @deprecated Use WhatsAppService.
 * It will be deleted when the embedded flow ends
 */
export class WhatsAppServiceDpr {
    static $inject = ['ConfigurationsService', 'MessagingHubService'];
    constructor(ConfigurationsService, MessagingHubService) {
        'ngInject';
        this.ConfigurationsService = ConfigurationsService;
        this.MessagingHubService = MessagingHubService;
    }
    setConfiguration(configuration, useConfigurationsApplication = false) {
        return this.ConfigurationsService.set(WHATSAPP_GATEWAY_IDENTITY, configuration, undefined, useConfigurationsApplication);
    }
    getConfiguration(useConfigurationsApplication = false) {
        return this.ConfigurationsService.get(WHATSAPP_GATEWAY_IDENTITY, undefined, useConfigurationsApplication);
    }
    deleteConfiguration(useConfigurationsApplication = false) {
        return Promise.all([
            this.ConfigurationsService.delete(WHATSAPP_GATEWAY_IDENTITY, undefined, useConfigurationsApplication),
            this.MessagingHubService.sendCommand({
                to: WHATSAPP_GATEWAY_IDENTITY,
                method: 'delete',
                uri: `${WHATSAPP_NATIVE_BASE_URI}/settings/application`,
            }),
        ]);
    }
    setPhoneNumberConfiguration(phoneConfiguration) {
        return this.MessagingHubService.sendCommand({
            to: WHATSAPP_GATEWAY_IDENTITY,
            method: 'set',
            uri: `${WHATSAPP_NATIVE_BASE_URI}/account`,
            type: 'application/json',
            resource: {
                cc: phoneConfiguration.countryCode,
                phone_number: phoneConfiguration.phoneNumber,
                method: phoneConfiguration.method,
                cert: phoneConfiguration.vNameCertificate,
                pin: phoneConfiguration.pincode,
            },
        });
    }
    verifyPhoneNumber(registrationCode, pincode = undefined) {
        return this.MessagingHubService.sendCommand({
            to: WHATSAPP_GATEWAY_IDENTITY,
            method: 'set',
            uri: `${WHATSAPP_NATIVE_BASE_URI}/account/verify`,
            type: 'application/json',
            resource: {
                code: registrationCode,
                pin: undefined,
            },
        });
    }
    setPhoneNumberPincode(pincode) {
        return this.MessagingHubService.sendCommand({
            to: WHATSAPP_GATEWAY_IDENTITY,
            method: 'set',
            uri: `${WHATSAPP_NATIVE_BASE_URI}/settings/account/two-step`,
            type: 'application/json',
            resource: {
                pin: pincode,
            },
        });
    }
    getAccountProfile() {
        return this.MessagingHubService.sendCommand({
            to: WHATSAPP_GATEWAY_IDENTITY,
            method: 'get',
            uri: '/account',
        });
    }
    setAccountProfile(account) {
        return this.MessagingHubService.sendCommand({
            to: WHATSAPP_GATEWAY_IDENTITY,
            method: 'set',
            uri: '/account',
            type: 'application/vnd.lime.account+json',
            resource: account,
        });
    }
    getHealth() {
        return this.MessagingHubService.sendCommand({
            to: WHATSAPP_GATEWAY_IDENTITY,
            method: 'get',
            uri: `${WHATSAPP_NATIVE_BASE_URI}/health`,
        });
    }
    getShards() {
        return this.MessagingHubService.sendCommand({
            to: WHATSAPP_GATEWAY_IDENTITY,
            method: 'get',
            uri: `${WHATSAPP_NATIVE_BASE_URI}/account/shards`,
        });
    }
    setShards(configuration) {
        return this.MessagingHubService.sendCommand({
            to: WHATSAPP_GATEWAY_IDENTITY,
            method: 'set',
            uri: `${WHATSAPP_NATIVE_BASE_URI}/account/shards`,
            type: 'application/json',
            resource: {
                cc: configuration.countryCode,
                phone_number: configuration.phoneNumber,
                shards: configuration.shards,
                pin: configuration.pincode,
                cert: configuration.vNameCertificate,
            },
        });
    }
}
WhatsAppServiceDpr.$inject = ['ConfigurationsService', 'MessagingHubService'];
export class WhatsAppConfiguration {
}
export class WhatsAppPhoneNumberConfiguration {
}
export class WhatsAppShardsConfiguration {
}
export class Account {
}
